import { logoCultureMap } from 'utils/insurance-logo-mapper/insurance-logo-mapper';
import { useMemo } from 'react';

/**
 *
 * @param {Array<any>} listToCheck - List to be duplicated until reach the length threshold
 * @param {number} threshold - Minimum list length required, the list are going to be duplicated until reach this length value.
 * @returns {Array<any>}
 */
function checkListLength (listToCheck, threshold = 10) {
    const checkedList = listToCheck;

    if (listToCheck instanceof Array) {
        while (checkedList.length < threshold) {
            checkedList.push(...checkedList);
        }
    }

    return checkedList;
}

/**
 * @function logos - Function that receives the culture value of the app an retrieves an array with all the logo images of the insurance company.
 * @param {string} culture - The value of the local culture, if the culture is undefined or not defined inside the mapper return a empty array
 * @returns {Array}
 */
export function logos (culture) {
    /** List of incurance company code of the selected companies to be showed in the home insurance slider */
    const whitelist = {
        'es-ar': [
            'lameridional',
            'nacion',
            'ZURICH',
            'mapfre',
            'riouruguay',
            'sancristobal',
            'rivadavia',
            'allianz',
            'sancor',
            'mercantilandina',
            'victoria',
            'norte',
            'lasegunda',
            'hdi',
            // 'rsa',
            'caruso',
            'provincia',
            'liderar',
            'ORBIS',
            'prudencia',
            'laequitativa',
            'integrity',
            'parana',
            'boston',
            'nivel',
            'cooperacionseguros',
            'galeno',
            'libra',
            'tpc',
            'experta',
            'galiciaseguros'
        ],
        'es-mx': [
            'qualitas_mx',
            'hdi_mx',
            'atlas_mx',
            'zurich_mx',
            'ana_mx',
            'generalseguros_mx',
            'sura_mx',
            'chubb_mx',
            'aig_mx',
            'aguila_mx',
            'latino_mx',
            'afirme_mx'
        ],
        'pt-br': [
            'ituranbr',
            'suhai',
            'hdibr',
            'sompo',
            'libertybr',
            'alirobr',
            'sulamerica',
            'tokiobr',
            'allianzbr',
            'thinksegbr',
            'portobr',
            'azulbr',
            'mapfrebr',
            'youse_br',
            'mitsui',
            'alfa',
            'sancorbr',
            'bradesco'
        ],
        'es-cl': ['aliro_cl', 'bci_cl', 'cardif_cl', 'consorcio_cl', 'continental_cl', 'fid_cl', 'hdi_cl', 'liberty_cl', 'mapfre_cl', 'reale_cl', 'renta_nacional_cl', 'porvenir_cl', 'sura_cl', 'zenit_cl', 'zurich_cl'],
        'es-co': ['allianz_co', 'axa_co', 'bolivar_co', 'hdi_co', 'liberty_co', 'mundial_co', 'sbs_co', 'solidaria_co', 'zurich_co'],
        'es-uy': [
            'lameridional',
            'nacion',
            'ZURICH',
            'mapfre',
            'riouruguay',
            'sancristobal',
            'rivadavia',
            'allianz',
            'sancor',
            'mercantilandina',
            'victoria',
            'norte',
            'lasegunda',
            'hdi',
            'rsa',
            'caruso',
            'provincia',
            'liderar',
            'ORBIS',
            'prudencia',
            'laequitativa',
            'integrity',
            'parana',
            'boston',
            'nivel',
            'cooperacionseguros',
            'galeno',
            'libra',
            'tpc',
            'experta'
        ],
        'es-py': [
            'lameridional',
            'nacion',
            'ZURICH',
            'mapfre',
            'riouruguay',
            'sancristobal',
            'rivadavia',
            'allianz',
            'sancor',
            'mercantilandina',
            'victoria',
            'norte',
            'lasegunda',
            'hdi',
            'caruso',
            'provincia',
            'liderar',
            'ORBIS',
            'prudencia',
            'laequitativa',
            'integrity',
            'parana',
            'boston',
            'nivel',
            'cooperacionseguros',
            'galeno',
            'libra',
            'tpc',
            'experta'
        ]
    };

    /** Verify if the culture is not undefined to iterate through the logo mapper utility */
    if (
        culture !== null &&
        logoCultureMap[culture] !== undefined &&
        logoCultureMap[culture].gray !== undefined
    ) {
        // The Logo Culture Map by culture and color gray
        const mapper = logoCultureMap[culture].gray;

        const logosList = whitelist[culture]
            /** Verify is the mapper has a key with the code, and is there a logo in the value */
            .filter((item) => {
                const mapperItem = mapper[item] || null;
                return mapperItem !== null;
            })
            .map((item) => mapper[item]);

        const checkedList = useMemo(() => (
            checkListLength(logosList)
        ));
        return checkedList;
    }

    return [];
}
